export default "__VITE_ASSET__Cf3bi4B9__"